// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { FunctionalComponent, h } from '@stencil/core';

import BonusCode from './BonusCode';
import NoFollowLink from './NoFollowLink';
import { FormattedPromotion } from '../../types';
import showTerms from '../../utils/terms';

interface PromotionCardProps {
    promotion: FormattedPromotion | null;
    logPromotionClick: () => void;
    handleBonusCodeClick?: () => void;
    bonusCodeWasClicked?: boolean;
    useBoxShadow?: boolean;
    promoValidDate?: string;
    terms?: 'geo' | 'affiliate';
}

const BonusPromotionCardLarge: FunctionalComponent<PromotionCardProps> = ({
    promotion,
    logPromotionClick,
    handleBonusCodeClick,
    bonusCodeWasClicked = false,
    useBoxShadow = false,
    promoValidDate = '',
    terms = 'geo',
}) => {
    const termsText = promotion ? showTerms(promotion, terms) : '';

    const propMarfeelConversion = promotion?.link && promotion?.link.includes('switchboard') ? 'switchboard-click' : '';

    return (
        <NoFollowLink
            class={useBoxShadow ? `item item__shadow font` : `item font`}
            onClick={logPromotionClick}
            href={promotion?.link}
        >
            <div style={{ backgroundColor: `#${promotion?.logoColor}` }}>
                <div
                    class="item__color-border"
                    style={{
                        backgroundColor: `#${promotion.logoColor}`,
                        background: `linear-gradient(0deg, rgb(0 0 0 / 40%) 0%, #${promotion.logoColor} 80%)`,
                    }}
                >
                    <div style={{ display: 'grid', justifyItems: 'center', paddingBottom: 'var(--spacing-small)' }}>
                        <div class="large__book-container">
                            {promotion ? (
                                <lazy-load-logo
                                    class="large__logo"
                                    logo={promotion.logo}
                                    promoId={promotion.id}
                                    logoColor={promotion.logoColor}
                                    width={60}
                                    height={60}
                                />
                            ) : (
                                <div class="skeleton-item__logo"></div>
                            )}
                            <div class="large__title">Promo Code</div>
                        </div>
                    </div>
                    <div class="large__content">
                        <div class="item__promo-container">
                            <div class={`${promotion ? '' : 'skeleton-'}large__description`}>
                                <div class="large__cta">{promotion?.cta}</div>
                            </div>
                        </div>
                        <div class="large__buttons">
                            {handleBonusCodeClick && (
                                <div class="bonus-yellow">
                                    <BonusCode
                                        bonusCode={promotion?.bonusCode}
                                        bonusCodeWasClicked={bonusCodeWasClicked}
                                        handleClick={handleBonusCodeClick}
                                        includeDescriptor={false}
                                    />
                                </div>
                            )}
                            <div class="large__button" data-mrf-conversion={propMarfeelConversion}>
                                <span class="large__button-font">{promotion?.buttonText || 'GET BONUSES'}</span>
                            </div>
                        </div>
                        <div class="large__terms">{termsText}</div>
                    </div>
                    <div class="large__date">
                        <p>
                            Verified <span class="large__date-bold">{promoValidDate}</span>
                        </p>
                    </div>
                </div>
            </div>
        </NoFollowLink>
    );
};

export default BonusPromotionCardLarge;
